import React, { Component } from "react";
import CartContext from "./CartContext";
import axios from "axios";
import { Table, Button, Modal, Form } from "react-bootstrap";

export default class ManufacturingTasks extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      tasks: [],
      showModal: false,
      users: [],
      currentTask: {
        taskName: "",
        taskDescription: "",
        seqNo: 1,
        assignedTo: "",
        statusId: 1,
        productManufacturingRequestOrderId: "",
      },
      // Filter states
      filterProduct: "",
      filterStatus: "1",
      filterAssignedTo: "",
    };
  }

  componentDidMount() {
    this.loadTasks();
    this.fetchUsers();
  }

  fetchUsers = () => {
    const storeId = this.context.storeId;
    axios
      .get(
        `${process.env.REACT_APP_API}AdminUsers/GetStoreUserAccounts/${storeId}`
      )
      .then((res) => this.setState({ users: res.data }))
      .catch(() => this.setState({ error: "Failed to load employees." }));
  };

  loadTasks = async () => {
    if (!this.context.storeId) return;
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}ProductManufacturingTasks/Store/${this.context.storeId}`
      );
      this.setState({ tasks: res.data });
    } catch (err) {
      alert(err.response?.data || err.message);
    }
  };

  openModal = (task = null) => {
    if (task) this.setState({ currentTask: task });
    else
      this.setState({
        currentTask: {
          taskName: "",
          taskDescription: "",
          seqNo: 1,
          assignedTo: "",
          statusId: 1,
          productManufacturingRequestOrderId: "",
        },
      });
    this.setState({ showModal: true });
  };

  closeModal = () => this.setState({ showModal: false });

  handleChange = (e) => {
    const { currentTask } = this.state;
    this.setState({
      currentTask: { ...currentTask, [e.target.name]: e.target.value },
    });
  };

  getStatusText = (statusId) => {
    switch (statusId) {
      case 1:
        return "Open";
      case 2:
        return "In-Progress";
      case 3:
        return "Closed";
      default:
        return "";
    }
  };

  handleSave = async () => {
    const { currentTask } = this.state;

    if (!currentTask.taskName) {
      alert("Task Name is required");
      return;
    }

    const payload = {
      id: currentTask.id,
      taskName: currentTask.taskName,
      taskDescription: currentTask.taskDescription,
      seqNo: currentTask.seqNo,
      statusId: currentTask.statusId,
      assignedTo: currentTask.assignedTo || null,
      productManufacturingRequestOrderId:
        currentTask.productManufacturingRequestOrderId,
    };

    try {
      if (currentTask.id) {
        await axios.put(
          `${process.env.REACT_APP_API}ProductManufacturingTasks/${currentTask.id}`,
          payload
        );
      } else {
        await axios.post(
          `${process.env.REACT_APP_API}ProductManufacturingTasks`,
          payload
        );
      }

      this.closeModal();
      this.loadTasks();
    } catch (err) {
      alert(err.response?.data || err.message);
    }
  };

  render() {
    const {
      tasks,
      showModal,
      currentTask,
      users,
      filterProduct,
      filterStatus,
      filterAssignedTo,
    } = this.state;

    // Apply filters
    const filteredTasks = tasks
      .filter((t) => !filterProduct || t.productName === filterProduct)
      .filter((t) => !filterStatus || t.statusId === Number(filterStatus))
      .filter((t) => !filterAssignedTo || t.assignedTo === filterAssignedTo);

    return (
      <div>
        <h4 className="py-3 fw-bold">Production Work Items/Tasks</h4>

        {/* Filters */}
        <div className="d-flex gap-3 mb-3">
          <Form.Select
            value={filterProduct}
            onChange={(e) => this.setState({ filterProduct: e.target.value })}
          >
            <option value="">All Products</option>
            {[...new Set(tasks.map((t) => t.productName))].map((p, i) => (
              <option key={i} value={p}>
                {p}
              </option>
            ))}
          </Form.Select>

          <Form.Select
            value={filterStatus}
            onChange={(e) => this.setState({ filterStatus: e.target.value })}
          >
            <option value="">All Status</option>
            <option value="1">Open</option>
            <option value="2">In-Progress</option>
            <option value="3">Closed</option>
          </Form.Select>

          <Form.Select
            value={filterAssignedTo}
            onChange={(e) =>
              this.setState({ filterAssignedTo: e.target.value })
            }
          >
            <option value="">All Assigned To</option>
            {users.map((u) => (
              <option key={u.id} value={u.id}>
                {u.emailId}
              </option>
            ))}
          </Form.Select>
        </div>

        <Table striped bordered hover className="mt-3">
          <thead>
            <tr>
              <th>Work Order</th>
              <th>Work Item/Task</th>
              <th>Description</th>
              <th>Status</th>
              <th>Assigned To</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredTasks.map((t) => (
              <tr key={t.id}>
                <td>{t.productName}</td>
                <td>{t.taskName}</td>
                <td>{t.taskDescription}</td>
                <td>{this.getStatusText(t.statusId)}</td>
                <td>{t.assignedToName}</td>
                <td>
                  <Button
                    variant="warning"
                    size="sm"
                    onClick={() => this.openModal(t)}
                  >
                    Edit
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Modal show={showModal} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {currentTask.id ? "Edit Task" : "Add Task"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-2">
                <Form.Label>Task Name</Form.Label>
                <Form.Control
                  type="text"
                  name="taskName"
                  value={currentTask.taskName}
                  onChange={this.handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Task Description</Form.Label>
                <Form.Control
                  type="text"
                  name="taskDescription"
                  value={currentTask.taskDescription}
                  onChange={this.handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Seq No</Form.Label>
                <Form.Control
                  type="number"
                  name="seqNo"
                  value={currentTask.seqNo}
                  onChange={this.handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  name="statusId"
                  value={currentTask.statusId}
                  onChange={this.handleChange}
                >
                  <option value="1">Open</option>
                  <option value="2">In-Progress</option>
                  <option value="3">Closed</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Assigned To</Form.Label>
                <Form.Select
                  name="assignedTo"
                  value={currentTask.assignedTo || ""}
                  onChange={this.handleChange}
                >
                  <option value="">Select User</option>
                  {users.map((u) => (
                    <option key={u.id} value={u.id}>
                      {u.emailId}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.handleSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
